module.exports = __webpack_public_path__ + "assets/img/home-product-advantage-light.e8a0cea9.png";